import React from 'react'
import { TableCell, TableRow } from '@mui/material'
import UserImg from '../assests/sampleuser.svg'
import ReyLeaf from '../../common/assests/reyleafLogo.svg'
import configuration from '../../config/Config'



const OrderProductManagementRow = ( {rows} ) => {

    
    return (
        <TableRow key={rows?.product?._id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
            <TableCell>
                <img
                    src={
                       rows?.product?.photos &&  rows?.product?.photos?.length > 0 
                        ? `${configuration.cdnFront}/${ rows?.product?.photos[0].url}`
                        : ReyLeaf 
                    }
                alt="Product-img"
                 className="orderProductsImage" />
            </TableCell>
            <TableCell>{rows?.product?.title||"-"}</TableCell>
            <TableCell>{rows?.product?.categoryId?.name||"-"}</TableCell>
            <TableCell>{rows?.quantity}</TableCell>
            <TableCell>{`$${rows?.product?.price||"-"}`}</TableCell>
            <TableCell>{`$${(rows?.quantity * (rows?.product?.discountedProce || 0)).toFixed(2) || "0.00"}`}</TableCell>
            <TableCell>{`$${rows?.product?.discountedProce||"-"}`}</TableCell>
        </TableRow>
    )
}

export default OrderProductManagementRow